import React from 'react';

export default function Button({ children, variant = 'primary', size = 'md', className = '', ...props }) {
  const baseStyles = 'font-semibold rounded transition-all duration-200';

  const variants = {
    primary: 'bg-therablue text-white hover:bg-blue-600',
    secondary: 'bg-gray text-text hover:bg-gray-700',
    outline: 'border-2 border-neutral-300 text-neutral-900 hover:bg-neutral-100',
  };

  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-5 py-2 text-base',
    lg: 'px-6 py-3 text-lg',
  };

  return (
    <button className={`cursor-pointer ${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props}>
      {children}
    </button>
  );
}
